import { Calendar } from "../../calendar/calendar";
import { Select } from "../../select/select";
import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { DateQuestionProps } from "../types";

export const DateQuestion = (props: DateQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    disabled,
    handleChange,

    size,
    isYearOnlyDate,
    isClearable = true,
    isSearchable = false,
    contentClassName,
    menuPlacement,
    options,
    locale,
    dateFormat,
    isInsideIframe,
    answerProps,
    answerAriaLabel,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps,
    dateYearSelectDataTestId,
    dateCalendarInputDataTestId
  } = props;

  const headerFooterProps = {
    gap,
    required,
    invalid,
    labelClassName,
    questionId,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        {isYearOnlyDate ? (
          <Select
            id={questionId}
            isClearable={isClearable}
            size={size}
            value={answer}
            menuPlacement={menuPlacement}
            isSearchable={isSearchable}
            onChange={handleChange}
            classNamePrefix="ehq-dropdown"
            className={contentClassName}
            placeholder={placeholder}
            options={options}
            {...answerProps}
            data-testid={dateYearSelectDataTestId}
          />
        ) : (
          <Calendar
            id={questionId}
            disabled={disabled}
            onChange={handleChange}
            className={contentClassName}
            size={size}
            selected={answer ? new Date(answer) : null}
            locale={locale}
            placeholderText={placeholder}
            dateFormat={dateFormat}
            ariaLabel={answerAriaLabel}
            isInsideIframe={isInsideIframe}
            {...answerProps}
            calendarInputDataTestId={dateCalendarInputDataTestId}
          />
        )}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
